import Immutable, { OrderedSet } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { DOCUMENT_MAX_HEIGHT, DOCUMENT_MAX_WIDTH, DOCUMENT_MIN_HEIGHT, DOCUMENT_MIN_WIDTH } from '../_config/Consts'
import { DocumentAction, DocumentActionType } from '../Document/_actions/DocumentActions'
import DocumentReducer from '../Document/_reducers/DocumentReducer'
import { HIDAction, HIDActionType } from '../HID/_actions/HIDActions'
import HIDReducer from '../HID/_reducers/HIDReducer'
import { LayerListAction, LayerListActionType } from '../LayerList/_actions/LayerListActions'
import LayerListReducer from '../LayerList/_reducers/LayerListReducer'
import ModuleBrightnessContrastStore from '../Module/ModuleBrightnessContrast/_stores/ModuleBrightnessContrastStore'
import ModuleChevronStore from '../Module/ModuleChevron/_stores/ModuleChevronStore'
import ModuleCircleStore from '../Module/ModuleCircle/_stores/ModuleCircleStore'
import ModuleGameboyStore from '../Module/ModuleGameboy/_stores/ModuleGameboyStore'
import ModuleHueStore from '../Module/ModuleHue/_stores/ModuleHueStore'
import ModuleImageStore from '../Module/ModuleImage/_stores/ModuleImageStore'
import ModuleKaleidoscopeStore from '../Module/ModuleKaleidoscope/_stores/ModuleKaleidoscopeStore'
import ModuleNoiseStore from '../Module/ModuleNoise/_stores/ModuleNoiseStore'
import ModulePixelateStore from '../Module/ModulePixelate/_stores/ModulePixelateStore'
import ModulePolygonStore from '../Module/ModulePolygon/_stores/ModulePolygonStore'
import ModuleRectangleStore from '../Module/ModuleRectangle/_stores/ModuleRectangleStore'
import ModuleSaturationStore from '../Module/ModuleSaturation/_stores/ModuleSaturationStore'
import ModuleTartanStore from '../Module/ModuleTartan/_stores/ModuleTartanStore'
import ModuleVibranceStore from '../Module/ModuleVibrance/_stores/ModuleVibranceStore'
import ModuleWallpaperGroupsStore from '../Module/ModuleWallpaperGroups/_stores/ModuleWallpaperGroupsStore'
import ModulePatternDesignServiceStore from '../Module/ModulePatternDesignService/_stores/ModulePatternDesignServiceStore'
import { ModuleAction, ModuleActionType } from '../Module/_actions/ModuleActions'
import ModuleInfo, { ModuleTypes } from '../Module/_config/ModuleInfo'
import * as ModuleResolver from '../Module/_config/ModuleResolver'
import ModuleStore, { IModuleStore } from '../Module/_stores/ModuleStore'
import ModuleCreatorReducer from '../ModuleCreator/_reducers/ModuleCreatorReducer'
import { ModuleListAction, ModuleListActionType } from '../ModuleList/_actions/ModuleListActions'
import ModuleListReducer from '../ModuleList/_reducers/ModuleListReducer'
import { ToolsAction, ToolsActionType } from '../Tools/_actions/ToolsActions'
import ToolsReducer from '../Tools/_reducers/ToolsReducer'
import Dimensions, { D } from '../Utils/Dimensions'
import { ViewerAction, ViewerActionType } from '../Viewer/_actions/ViewerActions'
import ViewerReducer from '../Viewer/_reducers/ViewerReducer'
import WindowReducer from '../Window/_reducers/WindowReducer'
import IntroReducer from '../Intro/_reducers/IntroReducer'
import { IntroAction } from '../Intro/_actions/IntroActions'
import { DOCUMENT_DATA_DPI } from '../_config/Consts'
import CreateStore from '../_stores/CreateStore'
import ImageListReducer from '../ImageList/_reducers/ImageListReducer'
import { AccountAction, AccountActionType } from '@af-common/UserData/_actions/UserAccountActions'
import { SidebarAction, SidebarActionType } from '../Sidebar/_actions/SidebarActions'
import { DocumentStatusTypes } from '../Document/_stores/DocumentStore'
import { CreateAction } from '_actions/CreateActions'
import { StorefrontRounded } from '@mui/icons-material'
import { v4 as uuidv4 } from 'uuid';

const CreateReducer = (store:CreateStore = new CreateStore(), action: HIDAction | ModuleListAction | ModuleAction | LayerListAction | ToolsAction | DocumentAction | ViewerAction | AccountAction | IntroAction | SidebarAction):CreateStore => {
	switch (action.type) {
		case AccountActionType.RemoveAccountData:
			store = new CreateStore()
			break

		case ToolsActionType.OnCenterDocument:
			store = centerDocument(store)
			break

		case ToolsActionType.OnToggleOverlay:
			store = centerDocument(store)
			break

		case HIDActionType.OnPlusDown:
			if(store.getIn(['hid', 'modDown']) == 'true')
				store = store.setIn(['document', 'dpi'], store.get('document').get('dpi') + 1)
			break

		case HIDActionType.OnMinusDown:
			if(store.getIn(['hid', 'modDown']) == 'true')
				store = store.setIn(['document', 'dpi'], Math.max(1, store.get('document').get('dpi') - 1))
			break

		case HIDActionType.OnDeleteDown:
			store = store.withMutations(store => {
				//Remove from layer
				let selectedLayerId = store.get('layerList').get('selectedLayerId')
				let selectedModuleId = store.get('moduleList').get('selectedModuleId')

				if(!selectedModuleId) return

				let selectedLayerStore = store.get('layerList').get('layers').get(selectedLayerId)

				let modules = selectedLayerStore.get('modules').valueSeq()
				let selectedModuleIndex:number = modules.keyOf(selectedModuleId)

				store.setIn(['layerList', 'layers', selectedLayerId, 'modules'], selectedLayerStore.get('modules').delete(selectedModuleId))

				//Remove from ModuleList
				store.setIn(['moduleList', 'modules'], store.get('moduleList').get('modules').delete(selectedModuleId))

				//Deselect if no more modules
				if(modules.count() === 1) {
					store.setIn(['moduleList', 'selectedModuleId'], null)
					return
				}

				//Select next module, or the last one if this was already the last
				let newModuleId:String
				if(selectedModuleIndex === modules.count() - 1) {
					newModuleId = modules.valueSeq().get(modules.count() - 2)
				} else {
					newModuleId = modules.valueSeq().get(selectedModuleIndex + 1)
				}

				store.setIn(['moduleList', 'selectedModuleId'], newModuleId)
			})
			break

		case HIDActionType.OnShiftDeleteDown:
			store = store.withMutations(store => {
				let layerId = store.get('layerList').get('selectedLayerId')
				
				store.setIn(['layerList', 'layers'], store.get('layerList').get('layers').delete(layerId))
				store.deleteIn(['layerList', 'layersOrder', layerId])
				store.setIn(['layerList', 'selectedLayerId'], store.get('layerList').get('layers').keySeq().last())

				//Deselect module
				store.setIn(['moduleList', 'selectedModuleId'], null)
			})
			break

		case HIDActionType.OnLeftDown: 			store = handleModuleMove('x', -1, store); break
		case HIDActionType.OnRightDown: 		store = handleModuleMove('x', 1,  store); break
		case HIDActionType.OnUpDown: 			store = handleModuleMove('y', -1, store); break
		case HIDActionType.OnDownDown: 			store = handleModuleMove('y', 1,  store); break
		case HIDActionType.OnShiftLeftDown: 	store = handleModuleMove('x', -10, store); break
		case HIDActionType.OnShiftRightDown:	store = handleModuleMove('x', 10,  store); break
		case HIDActionType.OnShiftUpDown: 		store = handleModuleMove('y', -10, store); break
		case HIDActionType.OnShiftDownDown: 	store = handleModuleMove('y', 10,  store); break

		case ModuleListActionType.OnModuleAdd:
			store = handleModuleAdd(action, store)
			break

		case LayerListActionType.OnLayerVisibility:
			//Deselect module if current layer is now hidden 
			if(action.id == store.getIn(['layerList', 'selectedLayerId'])) {
				store = store.setIn(['moduleList','selectedModuleId'], null)
			}
			break

		case LayerListActionType.OnLayerRemove:
			store = store.withMutations(store => {
				(store.getIn(['layerList', 'layers', action.id, 'modules']) as Immutable.OrderedSet<string>).forEach((value, key) => {
					store.setIn(['moduleList', 'modules'], store.get('moduleList').get('modules').delete(value))
				})
			})
			break

		case ModuleActionType.ModuleOnValueUpdate: {
			// Get limits
			let maxDimensions = null
			let moduleStore = store.getIn(['moduleList', 'modules', action.moduleId]) as any
			if (moduleStore.has('width') && moduleStore.has('height')) {
				let width = moduleStore.get('width')
				let height = moduleStore.get('height')
				maxDimensions = Dimensions.getModuleMaxDimensions(width, height, store.getIn(['document','width']) as number, store.getIn(['document','height']) as number)
			}

			let hasTrueLockRatio = store.hasIn(['moduleList', 'modules', action.moduleId, 'lockRatio']) ? store.getIn(['moduleList', 'modules', action.moduleId, 'lockRatio']) : false

			// Update both dimensions if an image ratio is locked
			if ((action.key == "lockRatio" && action.value == true) || (action.key != "lockRatio" && hasTrueLockRatio)) {
				let hasSource = store.hasIn(['moduleList', 'modules', action.moduleId, 'sourceWidth']) && store.hasIn(['moduleList', 'modules', action.moduleId, 'sourceHeight'])
				
				let width = hasSource && action.key == "width" ? action.value : store.getIn(['moduleList', 'modules', action.moduleId, 'width']) as number
				let height = hasSource && action.key == "height" ? action.value : store.getIn(['moduleList', 'modules', action.moduleId, 'height']) as number
				let ratio = hasSource ? (store.getIn(['moduleList', 'modules', action.moduleId, 'sourceWidth']) as number) / (store.getIn(['moduleList', 'modules', action.moduleId, 'sourceHeight']) as number) : width / height

				switch (action.key){
					case "width":
						store = store.setIn(['moduleList', 'modules', action.moduleId, 'height'], action.value / ratio)
						break
					case "height":
						store = store.setIn(['moduleList', 'modules', action.moduleId, 'width'], action.value * ratio)
						break
					case "lockRatio":
						if (hasSource){
							if (width > height) {
								store = store.setIn(['moduleList', 'modules', action.moduleId, 'width'], height * ratio)	
							} else {
								store = store.setIn(['moduleList', 'modules', action.moduleId, 'height'], width / ratio)
							}
						}
				}
			}

			// Resize the document on module transform if the module is attached
			if(store.getIn(['document','attachedModule']) === action.moduleId && ["rotation","width","height"].includes(action.key)) {
				let width = action.key === "width" ? action.value : store.getIn(['moduleList', 'modules', action.moduleId, 'width']) as number
				let height = action.key === "height" ? action.value : store.getIn(['moduleList', 'modules', action.moduleId, 'height']) as number
				let rotation = (action.key === "rotation" ? action.value : store.getIn(['moduleList', 'modules', action.moduleId, 'rotation'])) as number

				store = attachedModuleToDocument(store, action.moduleId, width, height, rotation)
			}

			// Do the actual update
			store = store.setIn(['moduleList', 'modules', action.moduleId, action.key], action.value)

			// Apply limits
			if (maxDimensions) {
				store = handleModuleMaxDimensions(store, action.moduleId, maxDimensions)
			}
			
			break
		}

		case ModuleActionType.ModuleOnMultipleValueUpdate: {
			// Get limits
			let maxDimensions = null
			let moduleStore = store.get('moduleList').get('modules').get(action.moduleId);
			if (moduleStore && moduleStore.has('width') && moduleStore.has('height')) {
				let width = moduleStore.get('width')
				let height = moduleStore.get('height')
				maxDimensions = Dimensions.getModuleMaxDimensions(width, height, store.getIn(['document','width']) as number, store.getIn(['document','height']) as number)
			}

			let shiftDown:boolean = store.get('hid').get('shiftDown')
			Object.keys(action.updates).forEach(key => {
				// Lock rotation angles for transformer
				if(key === "rotation" && !shiftDown) {
					action.updates[key] = Math.round(action.updates[key] / 15) * 15
				}

				// Resize the document on module transform if the module is attached
				if(store.getIn(['document','attachedModule']) === action.moduleId && ["rotation","width","height"].includes(key)) {
					let width = key === "width" ? action.updates[key] : store.getIn(['moduleList', 'modules', action.moduleId, 'width']) as number
					let height = key === "height" ? action.updates[key] : store.getIn(['moduleList', 'modules', action.moduleId, 'height']) as number
					let rotation = (key === "rotation" ? action.updates[key] : store.getIn(['moduleList', 'modules', action.moduleId, 'rotation'])) as number

					store = attachedModuleToDocument(store, action.moduleId, width, height, rotation)

					// Update limits
					maxDimensions = Dimensions.getModuleMaxDimensions(width, height, store.getIn(['document','width']) as number, store.getIn(['document','height']) as number)
				}

				store = store.setIn(['moduleList', 'modules', action.moduleId, key], action.updates[key])
			})

			// Apply limits
			if (maxDimensions) {
				store = handleModuleMaxDimensions(store, action.moduleId, maxDimensions)
			}

			break
		}

		case ModuleActionType.ModuleOnDuplicate: {
			const id = uuidv4()

			// Assume we're duplicating on this layer
			let selectedLayerId = store.get('layerList').get('selectedLayerId')

			// Create duplicate
			let module = store.getIn(['moduleList', 'modules', action.moduleId]) as ModuleStore
			if(ModuleResolver.hasId(module)) {
				module = module.set('id', id)
			}

			store = store.withMutations(store => {
				// Add to store
				store.setIn(['moduleList', 'modules', id], module)

				// Add to layer
				let layerModules = store.getIn(['layerList', 'layers', selectedLayerId, 'modules']) as OrderedSet<string>
				let newLayerModules = layerModules.takeUntil(v => v == action.moduleId).add(action.moduleId).add(id).concat(layerModules.skipUntil(v => v == action.moduleId).rest())
				store.setIn(['layerList', 'layers', selectedLayerId, 'modules'], newLayerModules)

				// Select new module
				store.setIn(['moduleList','selectedModuleId'], id)
			})

			break
		}

		case ModuleActionType.ModuleOnFitToTile: {
			const module = store.getIn(['moduleList', 'modules', action.moduleId]) as ModuleStore
			
			// Currently only supporting modules with this (user images basically)
			if(ModuleResolver.hasSourceDimensions(module)) {
				
				// First of all unattach module if it's attached
				if(store.getIn(['document','attachedModule']) == action.moduleId) {
					store = store.setIn(['document','attachedModule'], null)
				}

				const documentWidth = store.getIn(['document', 'width']) as number
				const documentHeight = store.getIn(['document', 'height']) as number

				let width = documentWidth, height = documentHeight

				const ratio = module.get('sourceRatio')
				if(ratio > 1) {
					height = width / ratio
				} else {
					width = height * ratio;
				}
				
				store = store.withMutations(store => {
					store.setIn(['moduleList', 'modules', action.moduleId, 'x'], documentWidth / 2)
					store.setIn(['moduleList', 'modules', action.moduleId, 'y'], documentHeight / 2)
					store.setIn(['moduleList', 'modules', action.moduleId, 'width'], width)
					store.setIn(['moduleList', 'modules', action.moduleId, 'height'], height)
					store.setIn(['moduleList', 'modules', action.moduleId, 'rotation'], 0)
				})
			}

			break
		}

		case DocumentActionType.OnAttachModule:
			if(action.moduleId != null) {
				let width = store.getIn(['moduleList', 'modules', action.moduleId, 'width']) as number
				let height = store.getIn(['moduleList', 'modules', action.moduleId, 'height']) as number

				// We want to reset the module's rotation when it's attached
				store = store.setIn(['moduleList', 'modules', action.moduleId, 'rotation'], 0)
				
				let rotation = store.getIn(['moduleList', 'modules', action.moduleId, 'rotation']) as number

				store = attachedModuleToDocument(store, action.moduleId, width, height, rotation)
			}

			store = store.withMutations(store => {
				store.setIn(['document', 'attachedModule'], action.moduleId);
				store.setIn(['document', 'lockRatio'], true);
			})
			break

		case DocumentActionType.OnChangeWidth: {
			let documentRatio = (store.getIn(['document','width']) as number) / (store.getIn(['document','height']) as number)
			store = store.setIn(['document', 'width'], Math.max(DOCUMENT_MIN_WIDTH, Math.min(DOCUMENT_MAX_WIDTH, action.value)));
			
			// Handle locked ratio
			if(store.hasIn(['document','lockRatio']) && store.getIn(['document','lockRatio']) == true) {
				store = store.setIn(['document','height'], Math.max(DOCUMENT_MIN_WIDTH, Math.min(DOCUMENT_MAX_WIDTH, action.value / documentRatio)))
			}

			// Handle attached module
			if(store.hasIn(['document', 'attachedModule']) && store.getIn(['document', 'attachedModule']) != null) {
				store = documentToAttachedModule(store, store.getIn(['document', 'attachedModule']) as string)
			}

			break
		}

		case DocumentActionType.OnChangeHeight: {
			let documentRatio = (store.getIn(['document','width']) as number) / (store.getIn(['document','height']) as number)
			store = store.setIn(['document', 'height'], Math.max(DOCUMENT_MIN_WIDTH, Math.min(DOCUMENT_MAX_WIDTH, action.value)));
			
			// Handle locked ratio
			if(store.hasIn(['document','lockRatio']) && store.getIn(['document','lockRatio']) == true) {
				store = store.setIn(['document','width'], Math.max(DOCUMENT_MIN_WIDTH, Math.min(DOCUMENT_MAX_WIDTH, action.value * documentRatio)))
			}

			// Handle attached module
			if(store.hasIn(['document', 'attachedModule']) && store.getIn(['document', 'attachedModule']) != null) {
				store = documentToAttachedModule(store, store.getIn(['document', 'attachedModule']) as string)
			}

			break
		}

		case DocumentActionType.OnZoom:
			//Make zoom feel nicer (works as percentage instead)
			let document = store.get('document')
			let dpi = document.get('dpi')
			let zoom:number = action.zoom / DOCUMENT_DATA_DPI * dpi
			
			let newDpi:number = Dimensions.calcDPI(dpi + zoom, document.get('width'), document.get('height'))
			let scale:number = newDpi / dpi

			//When overlay is on, delta is always centered
			if(store.getIn(['tools','overlay','enabled'])) {
				store = centerDocument(store, newDpi)
			} else {
				store = store.withMutations(store => {
					store.setIn(['document','offsetX'], document.get('offsetX')*scale - (scale - 1)*action.offsetX)
					store.setIn(['document','offsetY'], document.get('offsetY')*scale - (scale - 1)*(action.offsetY - 64))
				})
			}

			store = store.withMutations(store => {
				store.setIn(['document','dpi'], newDpi)
			})
			break

		case ViewerActionType.OnSetIsFullWidth:
			if(store.getIn(['tools','overlay','enabled'])) {
				store = centerDocument(store)
			}
			break

		case SidebarActionType.NewPattern:
			let newStore = new CreateStore()
			newStore = newStore.set('viewer', store.get('viewer'))
			newStore = newStore.set('window', store.get('window'))
			newStore = newStore.set('tools', store.get('tools'))
			newStore = newStore.set('hid', store.get('hid'))
			newStore = centerDocument(newStore)
			store = newStore
			break

		case SidebarActionType.NewDocument:
			store = store.setIn(['document', 'status'], DocumentStatusTypes.Edit)
			break

		case SidebarActionType.OnSaveSuccess:
			store = store.withMutations((store) => {
				store.setIn(['document', 'status'], DocumentStatusTypes.Saved)
				store.setIn(['document', 'savedId'], action.id)
			})
			break

		case SidebarActionType.OnSaveError:
			store = store.setIn(['document', 'status'], DocumentStatusTypes.Edit)
			break
	}

	return combineReducers({
		document: DocumentReducer,
		hid: HIDReducer,
		imageList: ImageListReducer,
		layerList: LayerListReducer,
		moduleCreator: ModuleCreatorReducer,
		moduleList: ModuleListReducer,
		tools: ToolsReducer,
		viewer: ViewerReducer,
		intro: IntroReducer,
		window: WindowReducer,
	})(store, action) as CreateStore
}

let centerDocument = (store:CreateStore, dpi?:number):CreateStore => {
	let document = store.get('document')
	dpi = dpi || document.get('dpi')
	let width:number = document.get('width') / DOCUMENT_DATA_DPI * dpi
	let height:number = document.get('height') / DOCUMENT_DATA_DPI * dpi

	//Center our pattern
	let viewer = store.get('viewer')
	return store.withMutations(store => {
		store.setIn(['document','offsetX'], viewer.get('width') / 2 - width / 2)
		store.setIn(['document','offsetY'], viewer.get('height') / 2 - height / 2)
	})
}

let handleModuleMove = (axis:('x'|'y'), value:number, store:CreateStore):CreateStore => {
	let selectedModuleId:string = store.get('moduleList').get('selectedModuleId')
	
	if(!selectedModuleId) return store

	let module = store.get('moduleList').get('modules').get(selectedModuleId)

	if(ModuleResolver.hasPosition(module)) {
		//Multiply value based on zoom level
		let multiplier:number = DOCUMENT_DATA_DPI / store.get('document').get('dpi')
		store = store.setIn(['moduleList', 'modules', selectedModuleId, axis], module.get(axis) + value*multiplier)
	}

	return store
}

let attachedModuleToDocument = (store: CreateStore, moduleId: string, width: number, height: number, rotation: number):CreateStore => {
	const rad = Math.abs((rotation % 90) * (Math.PI/180))

	const rwidth = width * Math.cos(rad) + height * Math.sin(rad)
	const rheight = width * Math.sin(rad) + height * Math.cos(rad)

	return store.withMutations(store => {
		store.setIn(['document','width'], Math.max(DOCUMENT_MIN_WIDTH, Math.min(DOCUMENT_MAX_WIDTH, Math.max(1, rwidth))))
		store.setIn(['document','height'], Math.max(DOCUMENT_MIN_HEIGHT, Math.min(DOCUMENT_MAX_HEIGHT, Math.max(1, rheight))))
		store.setIn(['moduleList', 'modules', moduleId, 'x'], rwidth/2)
		store.setIn(['moduleList', 'modules', moduleId, 'y'], rheight/2)
	})
}

let documentToAttachedModule = (store: CreateStore, moduleId: string): CreateStore => {
	const documentWidth = store.getIn(['document','width']) as number // 1265
	const documentHeight = store.getIn(['document','height']) as number // 1265
	const width = store.getIn(['moduleList', 'modules', moduleId, 'width']) as number // 1143
	const height = store.getIn(['moduleList', 'modules', moduleId, 'height']) as number // 1143
	const rotation = store.getIn(['moduleList', 'modules', moduleId, 'rotation']) as number // 20

	const rad = Math.abs((rotation % 90) * (Math.PI/180)) // 0.3490658503988659
	let newWidth = width * Math.cos(rad) + height * Math.sin(rad) // 1464.9976893795326
	let newHeight = width * Math.sin(rad) + height * Math.cos(rad) // 1464.9976893795326

	const scale = Math.min(documentWidth / newWidth, documentHeight / newHeight) // 0.8634825905669262

	newWidth = width * scale
	newHeight = height * scale

	return store.withMutations(store => {
		store.setIn(['moduleList', 'modules', moduleId, 'width'], newWidth)
		store.setIn(['moduleList', 'modules', moduleId, 'height'], newHeight)
		store.setIn(['moduleList', 'modules', moduleId, 'x'], documentWidth/2)
		store.setIn(['moduleList', 'modules', moduleId, 'y'], documentHeight/2)
	})
}

let handleModuleMaxDimensions = (store: CreateStore, moduleId: string, maxDimensions: D) => {
	// Apply limits to the module's props
	let moduleStore = store.getIn(['moduleList', 'modules', moduleId]) as any
	if (moduleStore.has('width') && moduleStore.has('height')) {
		return store.withMutations(store => {
			store.setIn(['moduleList','modules',moduleId,'width'], Math.max(1, Math.min(moduleStore.get('width'), maxDimensions.width)))
			store.setIn(['moduleList','modules',moduleId,'height'], Math.max(1, Math.min(moduleStore.get('height'), maxDimensions.height)))
		})
	}
	
	return store
}

let handleModuleAdd = (action:ModuleListAction, store:CreateStore) => {
	let moduleStore: IModuleStore
	
	let document = store.get('document')
	let width = document.get('width')
	let height = document.get('height')
	let minSize = Math.min(width, height)

	switch(action.moduleType){
		// ImageUpload is simply a UI construct not an actual module
		// it has an additional property UItype which is used to open the upload dialog
		case ModuleTypes.ImageUpload:
			moduleStore = new ModuleImageStore({
				name: ModuleInfo[ModuleTypes.Image].name,
				id: action.id,
				source: "",
				type: ModuleInfo[ModuleTypes.Image].type,
				UItype: ModuleTypes.ImageUpload
			})
			break
		case ModuleTypes.Image:
			moduleStore = new ModuleImageStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				id: action.id,
				source: "",
				type: ModuleInfo[action.moduleType as ModuleTypes].type,
			})
			break
		case ModuleTypes.Rectangle:
			moduleStore = new ModuleRectangleStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				color: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				width: Math.floor(Math.random() * width / 4) + width / 8,
				height: Math.floor(Math.random() * height / 4) + height / 8,
				x: Math.floor(Math.random() * width),
				y: Math.floor(Math.random() * height),
			})
			break
		case ModuleTypes.Circle:
			moduleStore = new ModuleCircleStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				color: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				radius: Math.floor(Math.random() * minSize / 4) + minSize / 8,
				x: Math.floor(Math.random() * width),
				y: Math.floor(Math.random() * height),
			})
			break
		case ModuleTypes.Polygon:
			moduleStore = new ModulePolygonStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				color: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				sides: 5,
				radius: Math.floor(Math.random() * minSize / 4) + minSize / 8,
				x: Math.floor(Math.random() * width),
				y: Math.floor(Math.random() * height),
			})
			break
		case ModuleTypes.Tartan:
			moduleStore = new ModuleTartanStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				color1: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				color2: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				bgColor: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				size1: 5,
				size2: 5,
			})
			break
		case ModuleTypes.Chevron:
			moduleStore = new ModuleChevronStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				color1: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				color2: ["#0089a3","#223d5c","#7aaed5","#005595","#008681","#2c3646","#00b09e","#872a39","#8a3f40","#bc2130","#f96722","#fbc11a","#ffff00","#f6992a","#a9dd76","#74952b","#007c49","#345c3e","#37a346","#fdafc0","#967aa2","#6a5595","#963071","#d85f95","#4f6d83","#615d56","#9ea9b1","#747573","#5e6162","#0b0d0d","#e4e8ff","#523834","#875b43","#ae846c","#cdbfac","#ad8e5e","#967d39"][Math.floor(Math.random() * 37)],
				angle: 45,
				thickness1: 5
			})
			break
		case ModuleTypes.Pixelate:
			moduleStore = new ModulePixelateStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				pixelSize: 5,
			})
			break
		case ModuleTypes.Noise:
			moduleStore = new ModuleNoiseStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				noise: 0.4,
			})
			break
		case ModuleTypes.Kaleidoscope:
			moduleStore = new ModuleKaleidoscopeStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				sides: Math.ceil(Math.random() * 6) * 2 + 2,
				angle: 0,
			})
			break
		case ModuleTypes.BrightnessContrast:
			moduleStore = new ModuleBrightnessContrastStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
				brightness: 0.1,
				contrast: 1,
			})
			break
		case ModuleTypes.Hue:
			moduleStore = new ModuleHueStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
		case ModuleTypes.Saturation:
			moduleStore = new ModuleSaturationStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
		case ModuleTypes.Vibrance:
			moduleStore = new ModuleVibranceStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
		case ModuleTypes.Gameboy:
			moduleStore = new ModuleGameboyStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
		case ModuleTypes.WallpaperGroups:
			moduleStore = new ModuleWallpaperGroupsStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
		case ModuleTypes.PatternDesignService:
			moduleStore = new ModulePatternDesignServiceStore({
				name: ModuleInfo[action.moduleType as ModuleTypes].name,
			})
			break
	}

	return store.withMutations(store => {
		store.setIn(['moduleList', 'modules'], store.getIn(['moduleList', 'modules']).set(action.id, moduleStore))
		store.setIn(['moduleList', 'selectedModuleId'], action.id)
	})
}

export default CreateReducer